/**
 * No-op exports for production builds
 *
 * These exports tree-shake to nothing in production, eliminating
 * all metrics overhead. Use Vite alias to swap to this in production.
 *
 * Vite config example:
 *   resolve: {
 *     alias: {
 *       'encamp-metrics': isProduction
 *         ? 'encamp-metrics/noop'
 *         : 'encamp-metrics'
 *     }
 *   }
 */
/**
 * No-op MetricsLogger - all methods do nothing
 */
export class MetricsLogger {
    constructor(_config) { }
    getSessionId() {
        return "";
    }
    isActive() {
        return false;
    }
    getCurrentAction() {
        return "";
    }
    setEnabled(_enabled) { }
    startRecording(_actionType) { }
    stopRecording() { }
    log(_event) { }
    logRender(_component, _meta) { }
    logQueryFire(_name, _variables) { }
    logQueryComplete(_name, _duration, _rowCount) { }
    logStateUpdate(_name, _value) { }
    logMilestone(_name, _meta) { }
    logRenderComplete(_component, _duration) { }
    getEvents() {
        return [];
    }
    getReport() {
        return "";
    }
    getWaterfall() {
        return "";
    }
    clear() { }
    // Wide event API no-ops
    getInteractionContext() {
        return new InteractionContext();
    }
    getWideEventStorage() {
        return new InMemoryStorage();
    }
    setWideEventsEnabled(_enabled) { }
    startInteraction(_action) {
        return "";
    }
    endInteraction() { }
    markTTI() { }
    emitWideEvent(_input) { }
    logUrlWrite(_params, _changedParams) { }
    logUrlRead(_params, _readParams) { }
    logContextWrite(_contextName, _changedKeys, _caused_by) { }
    logContextRead(_contextName, _readKeys) { }
    logRenderWide(_opts) { }
    logCommit(_opts) { }
    logQueryStart(_opts) { }
    logQueryResolve(_opts) { }
    logPaint() { }
    getCurrentInteractionEvents() {
        return [];
    }
    getAllWideEvents() {
        return [];
    }
    exportWideEventsJson() {
        return "[]";
    }
    getWideEventStats() {
        return { eventCount: 0, interactionCount: 0, componentCount: 0, queryCount: 0 };
    }
}
export function createMetricsLogger(_config) {
    return new MetricsLogger();
}
/**
 * No-op metricsLogger singleton
 */
export const metricsLogger = new MetricsLogger();
/**
 * No-op useRenderTracker hook
 */
export function useRenderTracker(_componentName, _props, _options) {
    return null;
}
/**
 * No-op useWhyDidYouUpdate hook
 */
export function useWhyDidYouUpdate(_componentName, _props) { }
/**
 * No-op useRenderCount hook - returns 0
 */
export function useRenderCount(_componentName) {
    return 0;
}
/**
 * No-op MetricsQuery class
 */
export class MetricsQuery {
    constructor(_source) { }
    async loadFromStorage() { }
    setEvents(_events) { }
    getActionSummary(_actionName) {
        return null;
    }
    getActionsByType(_type) {
        return [];
    }
    hasParallelQueries(_actionName) {
        return true;
    }
    getRenderCount(_actionName, _component) {
        return 0;
    }
    getOptimizationOpportunities() {
        return [];
    }
    getRenderCascades() {
        return [];
    }
    getWhyDidYouRenderReport(_component) {
        return {
            renderCount: 0,
            propChanges: new Map(),
            triggers: { props: 0, parent: 0, other: 0 },
            suggestion: "",
        };
    }
    getRenderCountsTable(_options) {
        return "";
    }
    getQueryWaterfall(_options) {
        return "";
    }
    getConsoleReport(_actionName) {
        return "";
    }
    exportBaseline(_commitSha, _page) {
        return {
            commitSha: "",
            date: "",
            page: "",
            summary: [],
            actions: [],
        };
    }
    generateMarkdownReport(_commitSha, _page) {
        return "";
    }
}
// Storage no-ops
export class MemoryStorage {
    async write(_lines) { }
    async read() {
        return [];
    }
    async clear() { }
    getLines() {
        return [];
    }
}
export class HttpStorage {
    constructor(_options) { }
    async write(_lines) { }
    async read() {
        return [];
    }
    async clear() { }
}
export class InMemoryStorage {
    constructor(_config) { }
    async initialize() { }
    async writeWideEvent(_event) { }
    async writeWideEvents(_events) { }
    queryByInteraction(_interactionId) {
        return [];
    }
    queryByComponent(_componentName) {
        return [];
    }
    queryByQueryName(_queryName) {
        return [];
    }
    queryByEventType(_eventType) {
        return [];
    }
    queryByTimeRange(_startTs, _endTs) {
        return [];
    }
    getInteractionIds() {
        return [];
    }
    getLastInteraction() {
        return null;
    }
    getInteractionByAction(_actionName) {
        return [];
    }
    getAllEvents() {
        return [];
    }
    aggregateRendersByComponent(_interactionId) {
        return new Map();
    }
    getQueryFires(_queryName, _interactionId) {
        return [];
    }
    async write(_lines) { }
    async read() {
        return [];
    }
    async clear() { }
    async flush() { }
    exportToJson() {
        return "[]";
    }
    importFromJson(_json) { }
    getEventCount() {
        return 0;
    }
    getStats() {
        return { eventCount: 0, interactionCount: 0, componentCount: 0, queryCount: 0 };
    }
}
export function createInMemoryStorage(_config) {
    return new InMemoryStorage();
}
export class InteractionContext {
    constructor(_sessionId) { }
    getSessionId() {
        return "";
    }
    isActive() {
        return false;
    }
    getCurrentInteractionId() {
        return "";
    }
    getCurrentAction() {
        return null;
    }
    getCurrentSpanId() {
        return "";
    }
    getParentSpanId() {
        return null;
    }
    startInteraction(_action) {
        return "";
    }
    endInteraction() {
        return null;
    }
    markTTI() { }
    startSpan(_name) {
        return "";
    }
    endSpan() { }
    generateCommitId() {
        return "";
    }
    getComponentId(_componentName, _key) {
        return "";
    }
    buildWideEvent(_input) {
        return {
            ts: 0,
            session_id: "",
            interaction_id: "",
            span_id: "",
            parent_span_id: null,
            route: "",
            url_params_hash: "",
            user_action: null,
            event_type: "RENDER",
            thread: "UI",
            commit_id: null,
            component_id: null,
            component_name: null,
            component_key: null,
            parent_component_id: null,
            reason_type: null,
            reason_keys: null,
            prev_hashes: null,
            next_hashes: null,
            ref_only: false,
            duration_ms: null,
            render_phase: null,
            query_name: null,
            query_id: null,
            vars_hash: "",
            vars_json: null,
            fetch_policy: null,
            cache_status: null,
            request_id: null,
            response_size: null,
            caused_by: null,
        };
    }
    hashRef(_obj) {
        return "";
    }
    hashVars(_vars) {
        return "";
    }
}
export function getInteractionContext() {
    return new InteractionContext();
}
export function createInteractionContext(_sessionId) {
    return new InteractionContext();
}
export function setDefaultInteractionContext(_context) { }
// Instrumentation no-ops
export function createMetricsLink(_config) {
    return (_operation, forward) => forward(_operation);
}
export function createMetricsApolloLink(_ApolloLink, _config) {
    return {};
}
export function getQueryName(_document) {
    return "";
}
export function hashVariables(_variables) {
    return "";
}
export function createTrackedSetSearchParams(originalSetSearchParams, _getCurrentParams, _logger, _name) {
    return originalSetSearchParams;
}
export function createUseTrackedSearchParams(_logger) {
    return function useTrackedSearchParams(useSearchParamsHook, _name) {
        return useSearchParamsHook();
    };
}
export function createUrlChangeDetector(_logger) {
    return () => { };
}
export function useUrlParamTracker(_logger, _searchParams, _readKeys) { }
export function createUrlCausedBy(_param) {
    return { type: "url_change", param: _param };
}
//# sourceMappingURL=noop.js.map